import React from "react";
import { styled } from "theme/default/styled";

export const SUsersChangeRowGroupInputIcon = styled.button<React.ButtonHTMLAttributes<HTMLButtonElement>>`
  margin-left: 32px;
`;
